import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { useI18n } from "vue-i18n/index";

/**
 * Sets current page breadcrumbs
 * @param {string} pageTitle Current page title
 * @param {Array<string>} breadcrumbs Current page breadcrumbs
 */
export const setCurrentPageBreadcrumbs = (
  pageTitle: string,
  breadcrumbs: Array<string>
): void => {

  const { t, te } = useI18n();
  let key: string = pageTitle.charAt(0).toLowerCase() + pageTitle.slice(1).replace(" ","")
  let breadcrumbsTitles: Array<string> = []
  let k: string
  for (let b of breadcrumbs){
    k = b.charAt(0).toLowerCase() + b.slice(1).replace(" ","")
    breadcrumbsTitles.push(te(k) ? t(k) : b)
  }
  store.dispatch(Actions.SET_BREADCRUMB_ACTION, {
    title: te(key) ? t(key) : pageTitle,
    pageBreadcrumbPath: breadcrumbsTitles,
  });
};

/**
 * Sets current page breadcrumbs
 * @param {string} title Current page title name
 */
export const setCurrentPageTitle = (title: string): void => {
  const { t, te } = useI18n();
  let key: string = title.charAt(0).toLowerCase() + title.slice(1).replace(" ","")
  store.dispatch(Actions.SET_BREADCRUMB_ACTION, {
    title: te(key) ? t(key) : title,
  });
};
